<template>
  <div class="mb-16 molecule popular-posts">
    <h3 class="mb-6 text-lg font-medium text-gray-800 font-ubuntu">
      {{ heading }}
    </h3>
    <ul>
      <li v-for="post in molecule.posts" class="mb-7">
        <a :href="post.uri" class="flex flex-col hover:bg-gray-100">
          <img
            v-if="post.image"
            v-bind="useResponsiveImage(post.image, 'thumb-small')"
            class="object-cover w-full h-24 bg-gray-300 mb-1.5"
          />
          <span
            class="text-sm font-medium category font-ubuntu text-bc-blue mb-1.5"
            >{{ post.category }}</span
          >
          <span class="text-base font-semibold title font-archer mb-1.5">{{
            post.title
          }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<style>
.molecule.popular-posts {
}
</style>

<script setup>
const props = defineProps({
  molecule: Object,
});

const route = useRoute();

const heading = computed(() => {
  if (
    route.name === "lifestyle-reviews" ||
    route.name === "lifestyle-reviews-category-category" ||
    route.name === "lifestyle-reviews-testimonial"
  ) {
    return "Featured Reviews";
  } else {
    return "Most Popular Posts";
  }
});
</script>
